import { memo } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import { getCRMObjectId } from '../call-message/operators/callMessageGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import PortalIdParser from 'PortalIdParser';
import CallMessagePropType from '../operators/CallMessagePropType';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function ReviewCallRecord({
  callMessage
}) {
  const crmObjectId = getCRMObjectId(callMessage);
  const portalId = PortalIdParser.get();
  const callReviewPageUrl = `${getFullUrl('app')}/calls/${portalId}/review/${crmObjectId}`;
  return crmObjectId ? /*#__PURE__*/_jsx(View, {
    marginBlockStart: "200",
    marginBlockEnd: "300",
    as: "div",
    children: /*#__PURE__*/_jsx(Link, {
      external: true,
      href: callReviewPageUrl,
      "data-test-id": "call-review-page-url",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-calling-message.timeline-call-metadata.call-review"
      })
    })
  }) : null;
}
ReviewCallRecord.propTypes = {
  callMessage: CallMessagePropType.isRequired
};
export default /*#__PURE__*/memo(ReviewCallRecord);